import { useState } from "react";
import type { Faq } from "@/mocks/faqs";

interface FaqAccordionProps {
  items: Faq[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-800 overflow-hidden rounded-lg border border-background-800 bg-background-900">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-800/60 md:px-6 md:py-5"
              >
                <span className="flex items-start gap-3 font-heading text-base font-semibold text-foreground-100">
                  <span className="mt-0.5 text-sm text-primary-400">{String(index + 1).padStart(2, "0")}</span>
                  {item.question}
                </span>
                <i
                  className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                    open ? "ri-subtract-line text-primary-400" : "ri-add-line"
                  }`}
                />
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-out ${
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-400 md:px-6 md:pb-6 md:pl-[3.4rem]">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}